import { render, staticRenderFns } from "./Customizer.vue?vue&type=template&id=31edf67b&scoped=true&"
import script from "./Customizer.vue?vue&type=script&lang=js&"
export * from "./Customizer.vue?vue&type=script&lang=js&"
import style0 from "./Customizer.vue?vue&type=style&index=0&id=31edf67b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31edf67b",
  null
  
)

component.options.__file = "Customizer.vue"
export default component.exports